<script lang="ts">
    import Locales from './SettingsLocales.svelte';
    import SettingsServiceTime from './SettingsServiceTime.svelte';
    import SettingsRouteParams from './SettingsRouteParams.svelte';
    import SettingsMessageText from './SettingsMessageText.svelte';
    import SettingsRouteSendTime from './SettingsRouteSendTime.svelte';
    import SettingsDisplay from './SettingsDisplay.svelte';
    import SettingsExport from './SettingsExport.svelte';
    import SettingsAccount from './SettingsAccount.svelte';
    import SettingsMigration from './SettingsMigration.svelte';
    import { SettingsManager } from './SettingsManager';
    import SettingsRouteCost from './SettingsRouteCost.svelte';
    import { features } from '../../shared/Features/features';
    import SettingsOverloadActions from './SettingsOverloadActions.svelte';
    import SettingsOverloadActionsWhenPlanning from './SettingsOverloadActionsWhenPlanning.svelte';
    import DeliveryListSettings from './DeliveryListSettings/DeliveryListSettings.svelte';

    export let selectedTab: string = 'appearance';

    function updateCustomer() {
        SettingsManager.updateCustomer();
    }

    function updateClient() {
        SettingsManager.updateClient();
    }
</script>

<div style="margin-bottom: 50px;">
    <div>
        {#if selectedTab === 'appearance'}
            <Locales {updateClient} />
            <SettingsDisplay {updateClient} />
        {:else if selectedTab === 'route-planning'}
            <SettingsRouteSendTime update={updateCustomer} />
            <SettingsServiceTime update={updateCustomer} />
            {#if $features?.feature_enable_route_cost_settings}
                <SettingsRouteCost update={updateCustomer} />
            {/if}
            {#if $features.feature_enable_limit_vehicles_when_planning}
                <SettingsOverloadActionsWhenPlanning update={updateCustomer} />
            {/if}
            {#if $features.feature_enable_limit_vehicles_rejecting}
                <SettingsOverloadActions update={updateCustomer} />
            {/if}
            <SettingsRouteParams update={updateCustomer} />
        {:else if selectedTab === 'notifications'}
            <SettingsMessageText update={updateCustomer} />
        {:else if selectedTab === 'export'}
            <SettingsExport update={updateCustomer} />
            <DeliveryListSettings update={updateCustomer} />
        {:else if selectedTab === 'other'}
            <SettingsAccount />
            <SettingsMigration />
        {/if}
    </div>
</div>
